import { findAndReplaceImages } from './FindAndReplaceImages';
import { findAndReplaceBackgroundImages } from './FindAndReplaceBackgroundImages';

/**
 * The mutation observer for Images
 */
let observer: MutationObserver;

/**
 * The number of mutation events, pertaining to images, that have occurred.
 */
export let debugMutationEventCount = 0;

function findAndReplaceAllImages(target: HTMLElement) {
    findAndReplaceImages(target);
    findAndReplaceBackgroundImages(target);
}

/**
 * Start DOM mutation observer for Images
 */
export function startObserver(target?: Element, config?: MutationObserverInit): void {
    target = target || document.body;
    config = config || {
        attributes: true,
        attributeFilter: ['src', 'data-src', 'data-background-image'],
        childList: true,
        characterData: false,
        subtree: true,
    };

    observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            ++debugMutationEventCount;
            findAndReplaceAllImages(mutation.target as HTMLElement);
        });
    });

    // Cache all existing Images
    findAndReplaceAllImages(target as HTMLElement);

    // Cache all future Images
    observer.observe(target, config);
}

/**
 * Stop DOM mutation observer for Images
 */
export function stopObserver(): void {
    observer.disconnect();
}
